import { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getUploadProcessRoutine } from 'ducks/files/actions'

export const PROCESS_CHECK_MS = 5000
export const PROCESS_CHECK_MAX_MS = 180000

const isSettled = file => ['completed', 'failed'].includes(file?.status)

export const processFailures = files => (files || [])
  .filter(file => file?.status === 'failed')
  .map(file => ({ id: file.id, displayName: file.displayName, reason: file.failureReason || null }))

export const useUploadProcessFailures = (process, files) => {
  const dispatch = useDispatch()
  const [checking, setChecking] = useState(false)
  const filesRef = useRef(files)
  filesRef.current = files

  const processId = process?.processId
  const bpId = process?.bpId
  const unitId = process?.unitId

  useEffect(() => {
    if (!processId || !bpId) return undefined
    const request = () => dispatch(getUploadProcessRoutine({ processId, bpId, ...(unitId ? { unitId } : {}) }))
    const startedAt = Date.now()
    setChecking(true)
    request()
    const timer = setInterval(() => {
      const current = filesRef.current || []
      const done = current.length > 0 && current.every(isSettled)
      if (done || Date.now() - startedAt >= PROCESS_CHECK_MAX_MS) {
        clearInterval(timer)
        setChecking(false)
        return
      }
      request()
    }, PROCESS_CHECK_MS)
    return () => {
      clearInterval(timer)
      setChecking(false)
    }
  }, [processId, bpId, unitId, dispatch])

  const failures = useMemo(() => processFailures(files), [files])
  return { failures, checking }
}
